module.exports = __webpack_public_path__ + "static/media/ticket-log.e3f285ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/ticket-log.png
// module id = 1109
// module chunks = 0